import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Android = ({
  height = 24,
  width = 24,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 140 140" {...props}>
    <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
      <path
        d="M5.5,21a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1V11H5.5Z"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M2.5,20.5v-8A1.326,1.326,0,0,1,4,11H5.5"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M21.5,20.5v-8A1.326,1.326,0,0,0,20,11H18.5"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M10.98 4.076L9.037 2.004"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.032 4.076L14.975 2.004"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M17.833,9a.5.5,0,0,0,.472-.666A6.543,6.543,0,0,0,12.006,4,6.538,6.538,0,0,0,5.691,8.34.5.5,0,0,0,6.164,9Z"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M10.25,6.5a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.75,6.5a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25"
        stroke={getColor(color, isColorInherited)}
        fill={getColor(color, isColorInherited)}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </SvgIcon>
);
